import React from 'react'
import { RotatingLines } from 'react-loader-spinner'

const Payment = () => {
    return (
        <div className='d-flex align-items-center justify-content-center' style={{
            height: "100vh"
        }}>
            <div>
                <div className='text-center'>
                    <RotatingLines
                        strokeColor="#00e194"
                        strokeWidth="4"
                        animationDuration="0.75"
                        width="90"
                        visible={true}
                    />
                </div>

                <p className='text-light'>Verifying payment, please wait</p>
            </div>
        </div >
    )
}

export default Payment